export default __webpack_public_path__ + "static/media/deeper-invitation.4f8f0a43.png";